module.exports = __webpack_public_path__ + "static/media/art1.10028685.png";


//////////////////
// WEBPACK FOOTER
// ./src/assests/images/art1.png
// module id = 1105
// module chunks = 0